import { defineMessages } from 'react-intl';

export default defineMessages({
  arrivalLabel: {
    description: 'Label for the estimated arrival time of a shipment',
    defaultMessage: 'Estimated Arrival',
    id: 'y8UkrM',
  },
});
